<p class="title">
	{{ 'MY_ACCOUNT_MENU.TITLE' | translate }}
</p>

<div *ngFor="let option of myAccountPages">
	<div
		*ngIf="!option.onlyPremium || (option.onlyPremium && userIsPremium)"
		class="option"
		[class.option__sub]="option.sub"
		[class.active]="option.path === currentPath"
		(click)="changePage(option.path)"
	>
		<span [class]="'freud-icon freud-icon-' + option.icon"></span>
		<p>{{ option.text + '.TITLE' | translate }}</p>
		<span class="freud-icon freud-icon-chevron-right"></span>
	</div>

	<div
		*ngIf="option.onlyPremium && !userIsPremium"
		freud-tooltip
		[tooltipLabel]="'MY_ACCOUNT_MENU.ONLY_PREMIUM' | translate"
		tooltipPosition="top"
	>
		<div class="option mobile-container" [class.option__sub]="option.sub">
			<span class="freud-icon freud-icon-diamond"></span>
			<div>
				<p>{{ option.text + '.TITLE' | translate }}</p>
				<div class="just-premium-card">
					{{ 'MY_ACCOUNT_MENU.ONLY_PREMIUM' | translate }}
				</div>
			</div>
		</div>
	</div>
</div>

<hr />

<div class="option" *ngIf="user?.profileUrl" [ngClass]="{'zk-default': !isUserActive}" (click)="isUserActive && openProfilePage()">
	<span class="freud-icon freud-icon-eye"></span>
	<p
		class="profile"
		freud-tooltip
		[tooltipLabel]="isUserActive ? null : ('MENU.PROFILE_TOOLTIP' | translate)"
	>
		{{ 'MY_ACCOUNT_MENU.VIEW_PROFILE' | translate }}
	</p>
</div>

<div class="ebook-card">
	<span class="freud-icon freud-icon-download"></span>
	<p>
		{{ 'MY_ACCOUNT_MENU.EBOOK_TEXT' | translate }}
		<br />
		<a href="/assets/ebooks/Ebook_Perfil_Campeao_Zenoffice.pdf" target="_blank">
			{{ 'MY_ACCOUNT_MENU.EBOOK_LINK' | translate }}
		</a>
	</p>
</div>
